import React, {Fragment, useState} from 'react';
import {Step4Form} from 'presentation/pages/public/forgot-password/components';
import {translations} from 'presentation/translations-new';
import {Typography} from '@mui/material';
import {Snackbar} from 'presentation/components';

const {successMessage} = translations['pt-br'].publicFlow.validateToken;
const {newPassword} = translations['pt-br'].publicFlow.forgotPassword;

export function Step4() {
	const [isSnackbarOpen, setIsSnackbarOpen] = useState(true);

	const handleCloseSnackbar = () => {
		setIsSnackbarOpen(false);
	};

	return (
		<Fragment>
			<Typography>{newPassword}</Typography>
			<Step4Form />
			<Snackbar
				onClose={handleCloseSnackbar}
				message={successMessage}
				open={isSnackbarOpen}
			/>
		</Fragment>
	);
}
